import { useEffect, useState } from 'react';
import * as vp from 'vopay';
import { Link } from 'react-router-dom';
import { useBranding } from '../../providers/Branding.provider';
import styles from './LoginContainer.module.scss';
import useFetchLoginPageBranding from '@/hooks/useApi/useFetchLoginPageBranding';

type LoginContainerProps = {
  children: React.ReactNode;
};

const LoginContainer: React.FunctionComponent<LoginContainerProps> = ({ children }) => {
  const { Box, Icon } = vp;
  const [brandingLoaded, setBrandingLoaded] = useState(false);
  const { logo, setBrandingValues } = useBranding();
  const { fetchLoginPageBranding } = useFetchLoginPageBranding();

  useEffect(() => {
    initBranding();
  }, []);

  async function initBranding() {
    const res = await fetchLoginPageBranding();

    if (!res.Success) {
      console.warn(res.ErrorMessage);
    }

    setBrandingValues({
      primaryColor: res.BrandingDetails.PrimaryColor,
      secondaryColor: res.BrandingDetails.SecondaryColor,
      logo: res.Logo,
      appTitle: res.AppTitle,
      appFavicon: res.Favicon,
    });

    setBrandingLoaded(true);
  }

  return (
    <div className={styles.loginContainer}>
      {brandingLoaded && (
        <Box flx="col" ai="center">
          {logo === '' && (
            <Link to={{ pathname: 'https://vopay.com' }} target="_blank">
              <div className={styles.logoContainer}>
                <Icon icon="vLogoText" width="100%" height="100%" />
              </div>
            </Link>
          )}
          {logo !== '' && (
            <div className={styles.logoContainer}>
              <img
                src={logo}
                style={{
                  maxWidth: '175px',
                  maxHeight: '100px',
                  width: 'auto',
                  height: 'auto',
                  minHeight: '50px', // Prevents collapsing to 0x0
                  objectFit: 'contain',
                }}
                alt="Logo"
              />{' '}
            </div>
          )}
          <div className={styles.formContainer}>
            <Box mt="lg" flx="col" ai="center" pe="xmd" ps="xmd" pt="md" pb="md" boundary="border" height="auto">
              {children}
            </Box>
          </div>
        </Box>
      )}
    </div>
  );
};

export default LoginContainer;
